// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@sc/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@sc/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

const _GaDispatchPDPShare: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (!state.xGoogleAnalytics.pdpShareEvent) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const product = props.parameter.product;


    const googleAnalyticsData = {
        event: state.xGoogleAnalytics.pdpShareEventName,
        page_path: getLocation(state).pathname,
        item_name: product?.productTitle || "",
        affiliation: state.xGoogleAnalytics.affiliation || "",
        sales_rep: state.xGoogleAnalytics.salesRep || "",
        is_rep: state.xGoogleAnalytics.isRep || "",
        bill_to_num: state.xGoogleAnalytics.billToNum || "",
        ship_to_num: state.xGoogleAnalytics.shipToNum || "",
        cust_type: state.xGoogleAnalytics.customerType || "",
        login_type: state.xGoogleAnalytics.loginType || "",
        warehouse: state.xGoogleAnalytics.warehouse || "",
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, ExecuteOnSuccessCallback, _GaDispatchPDPShare);
